import { useMemo } from 'react';
import { createTheme, ThemeProvider, useMediaQuery } from '@mui/material';
import './portal.css';
export default function PortalTheme({ children }) {
  const dark = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = useMemo(() => createTheme({
    palette: { mode: dark ? 'dark' : 'light', primary: { main: dark ? '#ffad80' : '#a84312' }, background: { default: dark ? '#191c20' : '#f7f8fa', paper: dark ? '#22262b' : '#fdfdfe' } },
    typography: { fontFamily: 'DW Roboto, Arial, sans-serif', button: { textTransform: 'none', fontWeight: 700 } },
    shape: { borderRadius: 8 },
    components: { MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { minHeight: 44, whiteSpace: 'nowrap' } } }, MuiLink: { defaultProps: { underline: 'hover' } } },
  }), [dark]);
  return <ThemeProvider theme={theme}><div className="portal" data-theme={dark ? 'dark' : 'light'}>{children}</div></ThemeProvider>;
}
